import { memo, useEffect, useState } from 'react';
import { shellHtml } from 'virtual:legacy';
import { bootLegacy } from './bridge/legacy-loader';
import { installTtsVoiceBridge } from './bridge/tts-voice';
import { applyMiniAppLaunch } from './platform/miniapp-launch';
import { platform } from './platform';
import { installServerState } from './bridge/server-state';
import { applyAppearance } from './features/settings/appearance';
import { isServerMode } from './platform/server-mode';
import { AccountData } from './features/profile/AccountData';
import { hasErasureReceipt } from './features/profile/account-data-state';
import { hasIdentityMerge } from './features/profile/identity-merge-state';
import { IdentityMergeRecovery } from './features/profile/IdentityMergeRecovery';
import { BootSkeleton } from './features/shell/BootSkeleton';

/** Разметка <body> прототипа. React её не перерисовывает: дальше ею владеет каркас (src/features/shell). */
const Shell = memo(function Shell() {
  return <div className="legacy-host" dangerouslySetInnerHTML={{ __html: shellHtml }} />;
});

export function App() {
  const [error, setError] = useState(false);
  const [ready, setReady] = useState(false);
  /* скелетон снимает себя сам (BootSkeleton): гаснет после готовности, а не исчезает в тот же кадр */
  const [skeleton, setSkeleton] = useState(true);
  /* один источник истины: своя копия условия не знала про стенд (VITE_MOCK_API) и каркас уезжал в демо-режим,
     пока «Студия» работала как серверная */
  const serverMode = isServerMode();
  useEffect(() => {
    bootLegacy(serverMode ? installServerState : undefined)
      .then(() => {
        if (serverMode) applyAppearance();
        installTtsVoiceBridge();
        applyMiniAppLaunch(platform.startParam());
        setReady(true);
      })
      .catch(() => setError(true));
  }, [serverMode]);
  if (error && serverMode && hasErasureReceipt()) return <main className="server-account"><h1>Статус удаления Mini App</h1><AccountData /></main>;
  if (error && serverMode && hasIdentityMerge()) return <IdentityMergeRecovery />;
  if (error) return <main role="alert">Не удалось открыть приложение. Откройте его из Telegram и попробуйте снова.</main>;
  return (
    <>
      <Shell />
      {serverMode && skeleton && <BootSkeleton done={ready} onGone={() => setSkeleton(false)} />}
    </>
  );
}
